import React from 'react';
import AlignmentAlerts from './AlignAlerts';
import { Typography } from '@material-ui/core';

const DashboardInsights = (props) => {

    const data = props.data

    // const filteredData = filterKeyValuePairs(data)

  // const valuesArray = Object.values(filteredData);

// console.log(data, 'vvagffuduasUF')

return (
  // Conditional rendering: Only render the div if 'data' exists
  data ? (
    <div style={{ marginBottom: '1.5rem' }}>
      {/*
        You had <Typography>{value}</Typography>, but 'value' was not defined.
        I've replaced it with 'displayValue' which takes the first value from filteredData.
        If you have a specific key you want to display, like data.someKey, use that instead.
      */}
      {<Typography variant='body2' style={{ marginBottom: '0.5rem' }}>{data.header}</Typography>}

      {/* Ensure data.textForAnnotationsTable exists before passing it */}
      {data.textForAnnotationsTable && (
        <AlignmentAlerts data={data.textForAnnotationsTable} />
      )}
    </div> 
  ) : null
);
};
export default DashboardInsights;


const filterKeyValuePairs = (obj) => {
    const result = {};
    for (const key in obj) {
      if (typeof obj[key] !== 'object') {
        result[key] = obj[key];
      }
    }
    return result;
  }